import Vue from 'vue';
import {indexOf, map} from 'lodash';
import {createStatus, loadStatuses, removeStatus, updateStatus} from '../../modules/api/status.api';

export const getters = {
    statuses:                (state) => state.statuses,
    customStatuses:          (state) => state.statuses.filter(({ systemic }) => false === systemic),
    systemStatuses:          (state) => state.statuses.filter(({ systemic }) => true === systemic),
    statusesForAutocomplete: (state) => state.statuses.map(({ id, title }) => {
        return { name: title, id };
    }),
    loadStatusById:          (state, getters) => (statusId) => {
        return new Promise((resolve) => resolve(getters.statuses.find((status) => status.id === statusId) || null));
    },
}

export const actions = {
    async createStatus({ commit, getters }, data) {
        const projectId = getters.projectId;
        return createStatus({ ...data, projectId }).then((data) => commit('ADD_STATUS', data))
    },
    async updateStatus({ commit }, data) {
        return updateStatus(data).then((data) => commit('UPDATE_STATUS', data))
    },
    async removeStatus({ commit }, statusId) {
        return removeStatus(statusId).then((id) => commit('REMOVE_STATUS', id))
    },
    async loadStatuses({ commit, getters }) {
        return loadStatuses(getters.projectId).then((data) => commit('SET_STATUSES', data));
    },
}

export const mutations = {
    SET_STATUSES:  (state, statusesData) => state.statuses = statusesData,
    ADD_STATUS:    (state, statusData) => state.statuses.push(statusData),
    UPDATE_STATUS: (state, statusData) => {
        const index = indexOf(map(state.statuses, (object) => object.id), statusData.id);
        Vue.set(state.statuses, index, statusData);
    },
    REMOVE_STATUS: (state, statusId) => {
        const index = indexOf(map(state.statuses, (object) => object.id), statusId);
        if (index !== -1) {
            state.statuses.splice(index, 1);
        }
    },
}
